import { render, staticRenderFns } from "./LawCounterPartyForm.vue?vue&type=template&id=e98b0a42&"
import script from "./LawCounterPartyForm.vue?vue&type=script&lang=js&"
export * from "./LawCounterPartyForm.vue?vue&type=script&lang=js&"
import style0 from "./LawCounterPartyForm.vue?vue&type=style&index=0&id=e98b0a42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports